document.addEventListener('DOMContentLoaded', function() {

  const sycModal = document.getElementById('modal__sizing-your-cane');
  const sycTrigger = document.querySelector('.syc-trigger');

  function openSycModal() {
    if (typeof sycModal.show === 'function') {
      sycModal.show();
    } else {
      sycModal.setAttribute('open', '');
      sycModal.removeAttribute('hidden');
    }
    sycTrigger.setAttribute('aria-expanded', 'true');
    // Move focus into modal for screen readers
    const firstFocusable = sycModal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) firstFocusable.focus();
  }

  function closeSycModal() {
    if (typeof sycModal.hide === 'function') {
      sycModal.hide();
    } else {
      sycModal.removeAttribute('open');
      sycModal.setAttribute('hidden', '');
    }
    sycTrigger.setAttribute('aria-expanded', 'false');
    stopSycVideo();
    // Return focus to trigger button
    sycTrigger.focus();
  }

  function stopSycVideo() {
    const iframe = sycModal.querySelector('iframe');
    if (iframe) {
      const src = iframe.src;
      iframe.src = '';
      iframe.src = src;
    }
  }

  if (sycTrigger && sycModal) {

    sycTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openSycModal();
    });

    const sycClose = sycModal.querySelector('.Modal__Close');
    if (sycClose) {
      sycClose.addEventListener('click', function(e) {
        e.preventDefault();
        closeSycModal();
      });
    }

    const sycOverlay = sycModal.querySelector('.overlay');
    if (sycOverlay) {
      sycOverlay.addEventListener('click', function() {
        closeSycModal();
      });
    }

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sycModal.hasAttribute('open')) {
        closeSycModal();
      }
    });

  }

});